import { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

type Props = {
  count?: number;
  className?: string;
};

export function Bubbles({ count = 14, className }: Props) {
  const reduced = useReducedMotion();
  const bubbles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: ((i * 73) % 100),
        size: 6 + ((i * 11) % 18),
        delay: (i * 0.4) % 6,
        dur: 3.5 + (i % 5) * 0.6,
      })),
    [count],
  );

  if (reduced) return null;

  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className || ""}`}>
      {bubbles.map((b) => (
        <motion.span
          key={b.id}
          initial={{ y: "100%", opacity: 0.0 }}
          animate={{ y: "-120%", opacity: [0, 0.6, 0] }}
          transition={{ duration: b.dur, delay: b.delay, repeat: Infinity, ease: "easeOut" }}
          style={{
            left: `${b.left}%`,
            width: b.size,
            height: b.size,
            border: "2px solid #1A0A12",
            background: "rgba(34, 211, 238, 0.4)",
          }}
          className="absolute bottom-0 rounded-full"
        />
      ))}
    </div>
  );
}

export default Bubbles;
